// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page-container {
  width: 100%;
  height: 100%;

  .login-section {
    width: 100%;
    height: 100%;
  }
  .login-layout {
    padding-top: 0 !important;
  }
  .form-label {
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    color: #1e2022;
  }
  .form-label-link {
    font-weight: 500;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    text-decoration: none;
  }
  .form-control-lg,
  .p-inputtext.p-password-input {
    min-height: calc(1.5em + 1.625rem);
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    border-radius: 0.3125rem;
  }
  .form-control,
  .p-inputtext.p-password-input {
    display: block;
    width: 100%;
    padding: 0.6125rem 1rem;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.5;
    color: #1e2022;
    background-color: #fff;
    background-clip: padding-box;
    border: 0.0625rem solid rgba(231, 234, 243, 0.7);
    appearance: none;
    border-radius: 0.3125rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .input-group-merge .input-group-append,
  .input-group-merge .input-group-prepend {
    position: absolute;
    top: 1px;
    bottom: 1px;
    z-index: 4;
    background-color: transparent;
  }
  .input-group-merge .input-group-append {
    right: 1px;
  }
  .input-group-merge .input-group-append.input-group-text,
  .input-group-merge .input-group-prepend.input-group-text {
    border-width: 0;
  }
  .input-group
    > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(
      .valid-feedback
    ):not(.invalid-tooltip):not(.invalid-feedback) {
    margin-left: -0.0625rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .btn-group-lg > .btn,
  .btn-lg {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    border-radius: 0.3125rem;
  }
  .content-space-t-4 {
    padding-top: 10rem !important;
  }
  .content-space-b-1 {
    padding-bottom: 3rem !important;
  }
  @media (min-width: 992px) {
    .content-space-t-lg-2 {
      padding-top: 5rem !important;
    }
    .min-vh-lg-100 {
      min-height: 100vh !important;
    }
  }
  /* 

:host ::ng-deep .p-password input {
    width: 15rem;
  } */

  .form-card-header {
    background: transparent;
    border: none;
  }

  .mt-8 {
    margin-top: 8rem !important;
  }
  .card.card-plain {
    background-color: transparent;
    box-shadow: none;
  }

  .text-gradient {
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    z-index: 1;
  }

  .text-gradient.text-info {
    background-image: linear-gradient(310deg, #006acd, #00c05b);
  }
  .bg-gradient-info {
    background-image: linear-gradient(270deg, #006acd, #006acd);
  }

  .btn-danger,
  .btn-danger:hover,
  .btn-dark,
  .btn-dark:hover,
  .btn-info,
  .btn-info:hover,
  .btn-primary,
  .btn-primary:hover,
  .btn-secondary,
  .btn-secondary:hover,
  .btn-success,
  .btn-success:hover,
  .btn-warning,
  .btn-warning:hover,
  .btn.bg-gradient-danger,
  .btn.bg-gradient-danger:hover,
  .btn.bg-gradient-dark,
  .btn.bg-gradient-dark:hover,
  .btn.bg-gradient-info,
  .btn.bg-gradient-info:hover,
  .btn.bg-gradient-primary,
  .btn.bg-gradient-primary:hover,
  .btn.bg-gradient-secondary,
  .btn.bg-gradient-secondary:hover,
  .btn.bg-gradient-success,
  .btn.bg-gradient-success:hover,
  .btn.bg-gradient-warning,
  .btn.bg-gradient-warning:hover {
    color: #fff;
  }
  .form-switch {
    padding-left: 3rem;
  }
  .form-switch .form-check-input {
    width: 2.5rem;
    margin-left: -3rem;
    background-image: none;
    background-position: 0;
    border-radius: 2.5rem;
    transition: background-color 0.25s ease, border-color 0.25s ease,
      background-position 0.15s ease-in-out, opacity 0.15s ease-out,
      box-shadow 0.15s ease-in-out;
  }
  .form-switch .form-check-input {
    border: 1px solid #e9ecef;
    position: relative;
    background-color: rgba(58, 65, 111, 0.1);
    height: 1.25em;
  }
  .form-switch .form-check-input:checked {
    border-color: rgba(58, 65, 111, 0.95);
    background-color: rgba(58, 65, 111, 0.95);
  }
  .form-switch .form-check-input:after {
    transition: transform 0.25s ease-in-out, background-color 0.25s ease-in-out;
    content: "";
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    position: absolute;
    background-color: #fff;
    transform: translateX(1px);
    box-shadow: 0 0.3125rem 0.625rem 0 rgba(0, 0, 0, 0.12);
    top: 1px;
  }
  .form-check-label {
    font-size: 0.875rem;
    font-weight: 400;
  }
  .form-switch .form-check-input:checked:after {
    transform: translateX(21px);
  }
  .oblique {
    transform: skewX(-8deg);
    overflow: hidden;
    width: 60%;
    right: -5rem;
    border-bottom-left-radius: 0.75rem;
  }
  .oblique .oblique-image {
    transform: skewX(8deg);
  }
  .bg-cover {
    background-size: cover;
  }
  .ms-n6 {
    margin-left: -4rem !important;
  }
  .me-n8 {
    margin-right: -8rem !important;
  }
  .ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
  }

  .page-header {
    width: 100%;
    height: 100%;
  }

  .font-weight-bolder {
    font-weight: 700 !important;
  }

  .min-vh-80 {
    min-height: 80vh;
  }
  a.link-text {
    font-size: 0.9rem;
    text-decoration: none;
    font-weight: 500;
    color: #64748b;
  }

  .password-input {
    display: flex;
  }

  .password-visible-controller {
    position: absolute;
    margin-left: 83%;
    margin-top: 2.5%;
    cursor: pointer;
  }
  .row-container {
    width: 100%;
    height: 100%;
    margin: 0;
  }

  .login-row {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .login-form-card-container {
    /* flex-basis: fit-content; */
    margin: auto;
  }

  .form-card {
    /* margin-top: 20%; */
    border: none;
  }

  .form-card-header {
    font-size: 19px;
  }

  .right-container {
    position: absolute;
    width: -webkit-fill-available;
    height: -webkit-fill-available;
    overflow-x: hidden;
    background-color: #0d1b2a;
  }

  .inputhoverBackground:focus{
    box-shadow: 0 0 0 .25rem rgba(253, 13, 13, 0.25) !important;
  }
  .right-side-image {
    width: 135%;
    height: 100%;
    object-fit: contain;
    object-position: left center;
    margin-left: -15%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/login.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;;EAEZ;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;;IAEE,kCAAkC;IAClC,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;;IAEE,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,gDAAgD;IAGhD,gBAAgB;IAChB,wBAAwB;IACxB,wEAAwE;EAC1E;EACA;;IAEE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;EACZ;EACA;;IAEE,eAAe;EACjB;EACA;;;;IAIE,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;;IAEE,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,+BAA+B;EACjC;EACA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;IAC9B;EACF;EACA;;;;KAIG;;EAEH;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,2DAA2D;EAC7D;EACA;IACE,2DAA2D;EAC7D;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA4BE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB;;kCAE8B;EAChC;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;EAChB;EACA;IACE,qCAAqC;IACrC,yCAAyC;EAC3C;EACA;IACE,2EAA2E;IAC3E,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,sDAAsD;IACtD,QAAQ;EACV;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kCAAkC;EACpC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,2DAA2D;EAC7D;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,iBAAiB;EACnB;AACF","sourcesContent":[".login-page-container {\n  width: 100%;\n  height: 100%;\n\n  .login-section {\n    width: 100%;\n    height: 100%;\n  }\n  .login-layout {\n    padding-top: 0 !important;\n  }\n  .form-label {\n    margin-bottom: 0.5rem;\n    font-size: 0.875rem;\n    color: #1e2022;\n  }\n  .form-label-link {\n    font-weight: 500;\n    font-size: 0.875rem;\n    margin-bottom: 0.5rem;\n    text-decoration: none;\n  }\n  .form-control-lg,\n  .p-inputtext.p-password-input {\n    min-height: calc(1.5em + 1.625rem);\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n    border-radius: 0.3125rem;\n  }\n  .form-control,\n  .p-inputtext.p-password-input {\n    display: block;\n    width: 100%;\n    padding: 0.6125rem 1rem;\n    font-size: 0.875rem;\n    font-weight: 600;\n    line-height: 1.5;\n    color: #1e2022;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 0.0625rem solid rgba(231, 234, 243, 0.7);\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-radius: 0.3125rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  }\n  .input-group-merge .input-group-append,\n  .input-group-merge .input-group-prepend {\n    position: absolute;\n    top: 1px;\n    bottom: 1px;\n    z-index: 4;\n    background-color: transparent;\n  }\n  .input-group-merge .input-group-append {\n    right: 1px;\n  }\n  .input-group-merge .input-group-append.input-group-text,\n  .input-group-merge .input-group-prepend.input-group-text {\n    border-width: 0;\n  }\n  .input-group\n    > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(\n      .valid-feedback\n    ):not(.invalid-tooltip):not(.invalid-feedback) {\n    margin-left: -0.0625rem;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .btn-group-lg > .btn,\n  .btn-lg {\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n    border-radius: 0.3125rem;\n  }\n  .content-space-t-4 {\n    padding-top: 10rem !important;\n  }\n  .content-space-b-1 {\n    padding-bottom: 3rem !important;\n  }\n  @media (min-width: 992px) {\n    .content-space-t-lg-2 {\n      padding-top: 5rem !important;\n    }\n    .min-vh-lg-100 {\n      min-height: 100vh !important;\n    }\n  }\n  /* \n\n:host ::ng-deep .p-password input {\n    width: 15rem;\n  } */\n\n  .form-card-header {\n    background: transparent;\n    border: none;\n  }\n\n  .mt-8 {\n    margin-top: 8rem !important;\n  }\n  .card.card-plain {\n    background-color: transparent;\n    box-shadow: none;\n  }\n\n  .text-gradient {\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    position: relative;\n    z-index: 1;\n  }\n\n  .text-gradient.text-info {\n    background-image: linear-gradient(310deg, #006acd, #00c05b);\n  }\n  .bg-gradient-info {\n    background-image: linear-gradient(270deg, #006acd, #006acd);\n  }\n\n  .btn-danger,\n  .btn-danger:hover,\n  .btn-dark,\n  .btn-dark:hover,\n  .btn-info,\n  .btn-info:hover,\n  .btn-primary,\n  .btn-primary:hover,\n  .btn-secondary,\n  .btn-secondary:hover,\n  .btn-success,\n  .btn-success:hover,\n  .btn-warning,\n  .btn-warning:hover,\n  .btn.bg-gradient-danger,\n  .btn.bg-gradient-danger:hover,\n  .btn.bg-gradient-dark,\n  .btn.bg-gradient-dark:hover,\n  .btn.bg-gradient-info,\n  .btn.bg-gradient-info:hover,\n  .btn.bg-gradient-primary,\n  .btn.bg-gradient-primary:hover,\n  .btn.bg-gradient-secondary,\n  .btn.bg-gradient-secondary:hover,\n  .btn.bg-gradient-success,\n  .btn.bg-gradient-success:hover,\n  .btn.bg-gradient-warning,\n  .btn.bg-gradient-warning:hover {\n    color: #fff;\n  }\n  .form-switch {\n    padding-left: 3rem;\n  }\n  .form-switch .form-check-input {\n    width: 2.5rem;\n    margin-left: -3rem;\n    background-image: none;\n    background-position: 0;\n    border-radius: 2.5rem;\n    transition: background-color 0.25s ease, border-color 0.25s ease,\n      background-position 0.15s ease-in-out, opacity 0.15s ease-out,\n      box-shadow 0.15s ease-in-out;\n  }\n  .form-switch .form-check-input {\n    border: 1px solid #e9ecef;\n    position: relative;\n    background-color: rgba(58, 65, 111, 0.1);\n    height: 1.25em;\n  }\n  .form-switch .form-check-input:checked {\n    border-color: rgba(58, 65, 111, 0.95);\n    background-color: rgba(58, 65, 111, 0.95);\n  }\n  .form-switch .form-check-input:after {\n    transition: transform 0.25s ease-in-out, background-color 0.25s ease-in-out;\n    content: \"\";\n    width: 1rem;\n    height: 1rem;\n    border-radius: 50%;\n    position: absolute;\n    background-color: #fff;\n    transform: translateX(1px);\n    box-shadow: 0 0.3125rem 0.625rem 0 rgba(0, 0, 0, 0.12);\n    top: 1px;\n  }\n  .form-check-label {\n    font-size: 0.875rem;\n    font-weight: 400;\n  }\n  .form-switch .form-check-input:checked:after {\n    transform: translateX(21px);\n  }\n  .oblique {\n    transform: skewX(-8deg);\n    overflow: hidden;\n    width: 60%;\n    right: -5rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n  .oblique .oblique-image {\n    transform: skewX(8deg);\n  }\n  .bg-cover {\n    background-size: cover;\n  }\n  .ms-n6 {\n    margin-left: -4rem !important;\n  }\n  .me-n8 {\n    margin-right: -8rem !important;\n  }\n  .ps {\n    overflow: hidden !important;\n    overflow-anchor: none;\n    -ms-overflow-style: none;\n    touch-action: auto;\n    -ms-touch-action: auto;\n  }\n\n  .page-header {\n    width: 100%;\n    height: 100%;\n  }\n\n  .font-weight-bolder {\n    font-weight: 700 !important;\n  }\n\n  .min-vh-80 {\n    min-height: 80vh;\n  }\n  a.link-text {\n    font-size: 0.9rem;\n    text-decoration: none;\n    font-weight: 500;\n    color: #64748b;\n  }\n\n  .password-input {\n    display: flex;\n  }\n\n  .password-visible-controller {\n    position: absolute;\n    margin-left: 83%;\n    margin-top: 2.5%;\n    cursor: pointer;\n  }\n  .row-container {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n  }\n\n  .login-row {\n    width: 100%;\n    height: 100%;\n    display: flex;\n  }\n\n  .login-form-card-container {\n    /* flex-basis: fit-content; */\n    margin: auto;\n  }\n\n  .form-card {\n    /* margin-top: 20%; */\n    border: none;\n  }\n\n  .form-card-header {\n    font-size: 19px;\n  }\n\n  .right-container {\n    position: absolute;\n    width: -webkit-fill-available;\n    height: -webkit-fill-available;\n    overflow-x: hidden;\n    background-color: #0d1b2a;\n  }\n\n  .inputhoverBackground:focus{\n    box-shadow: 0 0 0 .25rem rgba(253, 13, 13, 0.25) !important;\n  }\n  .right-side-image {\n    width: 135%;\n    height: 100%;\n    object-fit: contain;\n    object-position: left center;\n    margin-left: -15%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
